import styled from "styled-components";
import "@fontsource/lexend";
import "@fontsource/bebas-neue";
import "@fontsource/merriweather";

export const PricingGrid = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  display: grid;
  gap: 24px;

  grid-template-columns: repeat(3, 1fr);

  @media screen and (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const PricingCard = styled.article`
  background: #474747;
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 20px;
  overflow: hidden;

  display: flex;
  flex-direction: column;
  height: 100%;

  box-shadow: 0 6px 24px rgba(0,0,0,0.35);
`;

export const PricingImage = styled.img`
  width: 100%;
  height: 620px;
  object-fit: cover;

  @media screen and (max-width: 768px) {
    height: ${({ mobileHeight }) => mobileHeight || "320px"};
  }
`;

export const PricingBody = styled.div`
  padding: 20px 20px 0 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1; /* pushes footer down for equal height cards */
`;

export const PricingTitle = styled.h4`
  font-family: "Merriweather";
  font-weight: 600;
  font-size: 24px;
  color: #fff;
  text-align: left;
`;

export const PricingList = styled.ul`
  margin: 0;
  padding-left: 18px; /* bullets */
  list-style: disc;
  color: #eaeaea;
  font-family: "Lexend";
  font-weight: 400;
  font-size: 16px;
  line-height: 1.6;

  li + li {
    margin-top: 6px;
  }
`;

export const PricingFooter = styled.div`
  margin: 20px;
  margin-top: 16px;
  background: #181818;
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 14px;

  padding: 16px;
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: space-between;

  @media screen and (max-width: 480px) {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }
`;

export const PricingFootText = styled.p`
  color: #cfcfcf;
  font-family: "Lexend";
  font-size: 14px;
  margin: 0;
`;

export const PricingButton = styled.button`
  appearance: none;
  border: 0;
  cursor: pointer;

  font-family: "Lexend";
  font-weight: 700;
  font-size: 14px;

  padding: 10px 16px;
  border-radius: 10px;

  background: #012D9C;           /* your brand primary */
  color: #FFE0DF;                 /* your secondary */
  transition: transform 0.08s ease, opacity 0.2s ease, box-shadow 0.2s ease;

  box-shadow: 0 4px 14px rgba(1,45,156,0.35);

  &:hover { opacity: 0.95; }
  &:active { transform: translateY(1px) scale(0.99); }
  &:focus-visible {
    outline: 2px solid #FFE0DF;
    outline-offset: 2px;
  }
`;

export const PricingBanner = styled.div`
  border-radius: 10px;
  padding: 25px 14px;
  margin-bottom: 10px;

  font-family: "Lexend";
  font-size: 22px;
  font-weight: 600;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 8px;

  background: ${(props) =>
    props.variant === "gold"
      ? "linear-gradient(90deg, #FFD700, #FFA500)" // gold gradient
      : props.variant === "diamond"
      ? "linear-gradient(90deg, #00c6ff, #0072ff)" // diamond gradient
      : "rgba(1,45,156,0.15)"};

  border: ${(props) =>
    props.variant === "gold"
      ? "1px solid #FFD700"
      : props.variant === "diamond"
      ? "1px solid #00c6ff"
      : "1px solid rgba(1,45,156,0.4)"};
`;